import draftToHtml from 'draftjs-to-html';

import { JSONObject } from 'global/graphql/scalars.type';
import { Box } from 'approot/shared/design-system/box/box.style';
import { Heading16, PStyled } from 'approot/shared/styles/typography.style';
import {
  ImageStatic,
  ImageThumbnailStatic,
} from 'approot/shared/images/images';
import { FlexCentreAlign } from 'approot/shared/styles/flex.style';

export const SettingsTitleView = ({
  title,
  value,
}: {
  title: string;
  value: string | null;
}) => {
  return (
    <Box $marginBottom={16}>
      <Heading16 as="h2" marginBottom={0}>
        {title}
      </Heading16>
      {value && <PStyled>{value}</PStyled>}
    </Box>
  );
};

export const SettingsRichtextView = ({
  title,
  value,
}: {
  title: string;
  value: JSONObject | null;
}) => {
  const contentMarkup = draftToHtml(value);

  return (
    <Box $marginBottom={16}>
      <Heading16 as="h2" marginBottom={0}>
        {title}
      </Heading16>
      {value && (
        <PStyled as="div" dangerouslySetInnerHTML={{ __html: contentMarkup }} />
      )}
    </Box>
  );
};

export const SettingsThumbnailView = ({
  title,
  imageUrl,
}: {
  title: string;
  imageUrl?: string | null;
}) => {
  return (
    <Box $marginBottom={16}>
      <Heading16 as="h2" marginBottom={8}>
        {title}
      </Heading16>
      <FlexCentreAlign>
        {imageUrl && <ImageThumbnailStatic imageUrl={imageUrl} width={200} />}
      </FlexCentreAlign>
    </Box>
  );
};

export const SettingsCoverImageView = ({
  title,
  imageUrl,
}: {
  title: string;
  imageUrl?: string | null;
}) => {
  return (
    <Box $marginBottom={16}>
      <Heading16 as="h2" marginBottom={8}>
        {title}
      </Heading16>
      <FlexCentreAlign>
        {imageUrl && <ImageStatic imageUrl={imageUrl} />}
      </FlexCentreAlign>
    </Box>
  );
};
